import React from "react";
import { Grid, Card, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import { useTranslate } from "src/locales";

interface PartographBornInfoProps {
    formData: any;
    handleChange: (key: string, value: any) => void;
    prezentationOptions: any[];
    waterBladderOptions: any[];
    genderOptions: any[];
    selectedGenderOption: any;
}

const PartographBornInfo: React.FC<PartographBornInfoProps> = ({
    formData,
    handleChange,
    prezentationOptions,
    waterBladderOptions,
    genderOptions,
    selectedGenderOption,
}) => {
    const { t } = useTranslate();

    return (
        <Card sx={{ marginBottom: "5px" }}>
            <Grid
                container
                sx={{
                    m: 1,
                    width: "calc(100% - 16px)",
                    p: 2,
                    borderBottom: "1px solid #E0E0E0",
                    backgroundColor: "#63B4FF33",
                    borderRadius: "10px",
                }}
            >
                <span style={{ fontWeight: "bold", fontSize: "1.2rem" }}>
                    {t("partograf-form.born-info")}
                </span>
            </Grid>

            <Grid
                item
                xs={12}
                md={12}
                xl={12}
                container
                spacing={3}
                sx={{
                    display: {
                        md: "flex",
                        xl: "flex",
                        xs: "flex",
                    },
                }}
            >
                <Grid item xs="auto" container sx={{ marginLeft: "10px" }}>
                    <Grid item xs={12} md={12} xl={12}>
                        <Grid
                            item
                            xs={12}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: {
                                    md: "flex-start",
                                    xl: "flex-start",
                                    sm: "flex-start",
                                    xs: "center",
                                },
                                padding: "8px 0",
                                justifyContent: {
                                    md: "left",
                                    xl: "left",
                                    xs: "center",
                                },
                            }}
                        >
                            <ByzMuiTypography variant="body1" sx={{ marginBottom: "4px" }}>
                                {t("partograf-form.login-key")}
                            </ByzMuiTypography>

                            <ByzMuiTextField
                                sx={{
                                    width: "240px",
                                }}
                                inputProps={{ maxLength: 20 }}
                                color="primary"
                                variant="outlined"
                                label=""
                                value={formData.FIRST_TOUCH || ""}
                                onChange={(e: any) => handleChange("FIRST_TOUCH", e.target.value)}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs="auto" container sx={{ marginLeft: "10px" }}>
                    <Grid item xs={12} md={12} xl={12}>
                        <Grid
                            item
                            xs={12}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: {
                                    md: "flex-start",
                                    xl: "flex-start",
                                    sm: "flex-start",
                                    xs: "center",
                                },
                                padding: "8px 0",
                                justifyContent: {
                                    md: "left",
                                    xl: "left",
                                    xs: "center",
                                },
                            }}
                        >
                            <ByzMuiTypography variant="body1" sx={{ marginBottom: "4px" }}>
                                {t("partograf-form.onset-of-pain")}
                            </ByzMuiTypography>

                            <ByzMuiDateTimePicker
                                sx={{
                                    width: "240px !important",
                                }}
                                label=""
                                format="dd/MM/yyyy HH:mm"
                                value={formData.PAIN_START_TIME || null}
                                onChange={(value: any) => handleChange("PAIN_START_TIME", value)}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs="auto" container sx={{ marginLeft: "10px" }}>
                    <Grid item xs={12} md={12} xl={12}>
                        <Grid
                            item
                            xs={12}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: {
                                    md: "flex-start",
                                    xl: "flex-start",
                                    sm: "flex-start",
                                    xs: "center",
                                },
                                padding: "8px 0",
                                justifyContent: {
                                    md: "left",
                                    xl: "left",
                                    xs: "center",
                                },
                            }}
                        >
                            <ByzMuiTypography variant="body1" sx={{ marginBottom: "4px" }}>
                                {t("partograf-form.birth-time")}
                            </ByzMuiTypography>

                            <ByzMuiDateTimePicker
                                sx={{
                                    width: "240px !important",
                                }}
                                label=""
                                format="dd/MM/yyyy HH:mm"
                                maxDateTime={new Date()}
                                value={formData.BIRTH_TIME || null}
                                onChange={(value: any) => {
                                    if (value && value > new Date()) return;
                                    handleChange("BIRTH_TIME", value);
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs="auto" container sx={{ marginLeft: "10px" }}>
                    <Grid item xs={12} md={12} xl={12}>
                        <Grid
                            item
                            xs={12}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: {
                                    md: "flex-start",
                                    xl: "flex-start",
                                    sm: "flex-start",
                                    xs: "center",
                                },
                                padding: "8px 0",
                                justifyContent: {
                                    md: "left",
                                    xl: "left",
                                    xs: "center",
                                },
                            }}
                        >
                            <ByzMuiTypography variant="body1" sx={{ marginBottom: "4px" }}>
                                {t("partograf-form.presentation")}
                            </ByzMuiTypography>

                            <ByzMuiSelect
                                sx={{
                                    width: "240px !important",
                                }}
                                renderInput={(params: any) => (
                                    <ByzMuiTextField {...params} label="" variant="outlined" />
                                )}
                                options={prezentationOptions}
                                multiple
                                disableCloseOnSelect
                                color="primary"
                                label={t("partograf-form.chose")}
                                placeholder={t("partograf-form.chose")}
                                value={prezentationOptions.filter(
                                    (_, i) => (Number(formData.PREZENTATION || 0) & (1 << i)) !== 0
                                )}
                                renderTags={(value: any[]) => {
                                    if (!Array.isArray(value) || value.length === 0) return null;
                                    const firstItem = value[0].label;
                                    const remainingCount = value.length - 1;
                                    return (
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                width: "100%",
                                                overflow: "hidden",
                                            }}
                                        >
                                            <span
                                                style={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }}
                                            >
                                                {firstItem}
                                            </span>
                                            {remainingCount > 0 && (
                                                <span
                                                    style={{
                                                        marginLeft: "6px",
                                                        backgroundColor: "#1976d2",
                                                        color: "white",
                                                        borderRadius: "10px",
                                                        padding: "2px 6px",
                                                        fontSize: "0.75rem",
                                                        fontWeight: "bold",
                                                        flexShrink: 0,
                                                    }}
                                                >
                                                    +{remainingCount}
                                                </span>
                                            )}
                                        </div>
                                    );
                                }}
                                onChange={(_e: any, newValue: any) => {
                                    const selectedOpts = Array.isArray(newValue) ? newValue : [];
                                    const mask = selectedOpts.reduce((acc, sel) => {
                                        const idx = prezentationOptions.findIndex(
                                            (opt) => opt.value === sel.value
                                        );
                                        return idx !== -1 ? acc | (1 << idx) : acc;
                                    }, 0);
                                    handleChange("PREZENTATION", mask);
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs="auto" container sx={{ marginLeft: "10px" }}>
                    <Grid item xs={12} md={12} xl={12}>
                        <Grid
                            item
                            xs={12}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: {
                                    md: "flex-start",
                                    xl: "flex-start",
                                    sm: "flex-start",
                                    xs: "center",
                                },
                                padding: "8px 0",
                                justifyContent: {
                                    md: "left",
                                    xl: "left",
                                    xs: "center",
                                },
                            }}
                        >
                            <ByzMuiTypography variant="body1" sx={{ marginBottom: "4px" }}>
                                {t("partograf-form.indication-of-sca")}
                            </ByzMuiTypography>

                            <ByzMuiTextField
                                sx={{
                                    width: "240px",
                                }}
                                inputProps={{ maxLength: 20 }}
                                color="primary"
                                variant="outlined"
                                label=""
                                value={formData.IS_SCA_INDICATION || ""}
                                onChange={(e: any) => handleChange("IS_SCA_INDICATION", e.target.value)}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs="auto" container sx={{ marginLeft: "10px" }}>
                    <Grid item xs={12} md={12} xl={12}>
                        <Grid
                            item
                            xs={12}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: {
                                    md: "flex-start",
                                    xl: "flex-start",
                                    sm: "flex-start",
                                    xs: "center",
                                },
                                padding: "8px 0",
                                justifyContent: {
                                    md: "left",
                                    xl: "left",
                                    xs: "center",
                                },
                            }}
                        >
                            <ByzMuiTypography variant="body1" sx={{ marginBottom: "4px" }}>
                                {t("partograf-form.height-(cm)")}
                            </ByzMuiTypography>

                            <ByzMuiTextField
                                sx={{
                                    width: "240px",
                                }}
                                inputProps={{ maxLength: 2 }}
                                color="primary"
                                variant="outlined"
                                label=""
                                value={formData.BABY_HEIGHT || ""}
                                onChange={(e: any) => {
                                    const val = e.target.value;
                                    if (val === "" || (/^\d+$/.test(val) && Number(val) <= 99)) {
                                        handleChange("BABY_HEIGHT", val);
                                    }
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs="auto" container sx={{ marginLeft: "10px" }}>
                    <Grid item xs={12} md={12} xl={12}>
                        <Grid
                            item
                            xs={12}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: {
                                    md: "flex-start",
                                    xl: "flex-start",
                                    sm: "flex-start",
                                    xs: "center",
                                },
                                padding: "8px 0",
                                justifyContent: {
                                    md: "left",
                                    xl: "left",
                                    xs: "center",
                                },
                            }}
                        >
                            <ByzMuiTypography variant="body1" sx={{ marginBottom: "4px" }}>
                                {t("partograf-form.head-circumference")}
                            </ByzMuiTypography>

                            <ByzMuiTextField
                                sx={{
                                    width: "240px",
                                }}
                                inputProps={{ maxLength: 5 }}
                                color="primary"
                                variant="outlined"
                                label=""
                                value={formData.BABY_HEAD_CIRCUMFERENCE || ""}
                                onChange={(e: any) => {
                                    const val = e.target.value;
                                    if (val === "" || /^\d{0,2}(\.\d{0,2})?$/.test(val)) {
                                        if (val === "" || Number(val) <= 99.99) {
                                            handleChange("BABY_HEAD_CIRCUMFERENCE", val);
                                        }
                                    }
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs="auto" container sx={{ marginLeft: "10px" }}>
                    <Grid item xs={12} md={12} xl={12}>
                        <Grid
                            item
                            xs={12}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: {
                                    md: "flex-start",
                                    xl: "flex-start",
                                    sm: "flex-start",
                                    xs: "center",
                                },
                                padding: "8px 0",
                                justifyContent: {
                                    md: "left",
                                    xl: "left",
                                    xs: "center",
                                },
                            }}
                        >
                            <ByzMuiTypography variant="body1" sx={{ marginBottom: "4px" }}>
                                {t("partograf-form.weight-(grams)")}
                            </ByzMuiTypography>

                            <ByzMuiTextField
                                sx={{
                                    width: "240px",
                                }}
                                inputProps={{ maxLength: 4 }}
                                color="primary"
                                variant="outlined"
                                label=""
                                value={formData.BABY_WEIGHT || ""}
                                onChange={(e: any) => {
                                    const val = e.target.value;
                                    if (val === "" || (/^\d+$/.test(val) && Number(val) <= 9999)) {
                                        handleChange("BABY_WEIGHT", val);
                                    }
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs="auto" container sx={{ marginLeft: "10px" }}>
                    <Grid item xs={12} md={12} xl={12}>
                        <Grid
                            item
                            xs={12}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: {
                                    md: "flex-start",
                                    xl: "flex-start",
                                    sm: "flex-start",
                                    xs: "center",
                                },
                                padding: "8px 0",
                                justifyContent: {
                                    md: "left",
                                    xl: "left",
                                    xs: "center",
                                },
                            }}
                        >
                            <ByzMuiTypography variant="body1" sx={{ marginBottom: "4px" }}>
                                {t("partograf-form.gender")}
                            </ByzMuiTypography>

                            <ByzMuiSelect
                                sx={{
                                    width: "240px !important",
                                }}
                                renderInput={(params: any) => (
                                    <ByzMuiTextField {...params} label="" variant="outlined" />
                                )}
                                options={genderOptions}
                                color="primary"
                                label={t("partograf-form.chose")}
                                placeholder={t("partograf-form.chose")}
                                value={selectedGenderOption}
                                onChange={(_e: any, option: any) =>
                                    handleChange("BABY_GENDER", option?.value ?? "")
                                }
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs="auto" container sx={{ marginLeft: "10px" }}>
                    <Grid item xs={12} md={12} xl={12}>
                        <Grid
                            item
                            xs={12}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: {
                                    md: "flex-start",
                                    xl: "flex-start",
                                    sm: "flex-start",
                                    xs: "center",
                                },
                                padding: "8px 0",
                                justifyContent: {
                                    md: "left",
                                    xl: "left",
                                    xs: "center",
                                },
                            }}
                        >
                            <ByzMuiTypography variant="body1" sx={{ marginBottom: "4px" }}>
                                {t("partograf-form.placenta-expulsion-time")}
                            </ByzMuiTypography>

                            <ByzMuiDateTimePicker
                                sx={{
                                    width: "240px !important",
                                }}
                                label=""
                                format="dd/MM/yyyy HH:mm"
                                value={formData.PLACENTA_EXIT_TIME || null}
                                onChange={(value: any) => handleChange("PLACENTA_EXIT_TIME", value)}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs="auto" container sx={{ marginLeft: "10px" }}>
                    <Grid item xs={12} md={12} xl={12}>
                        <Grid
                            item
                            xs={12}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: {
                                    md: "flex-start",
                                    xl: "flex-start",
                                    sm: "flex-start",
                                    xs: "center",
                                },
                                padding: "8px 0",
                                justifyContent: {
                                    md: "left",
                                    xl: "left",
                                    xs: "center",
                                },
                            }}
                        >
                            <ByzMuiTypography variant="body1" sx={{ marginBottom: "4px" }}>
                                {t("partograf-form.water-bladder")}
                            </ByzMuiTypography>

                            <RadioGroup
                                row
                                value={String(formData.IS_PLACENTA || "")}
                                onChange={(e) => handleChange("IS_PLACENTA", e.target.value)}
                                sx={{ width: "240px" }}
                            >
                                {waterBladderOptions.map((opt) => (
                                    <FormControlLabel
                                        key={opt.value}
                                        value={String(opt.value)}
                                        control={<Radio size="small" />}
                                        label={opt.label}
                                    />
                                ))}
                            </RadioGroup>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs="auto" container sx={{ marginLeft: "10px" }}>
                    <Grid item xs={12} md={12} xl={12}>
                        <Grid
                            item
                            xs={12}
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: {
                                    md: "flex-start",
                                    xl: "flex-start",
                                    sm: "flex-start",
                                    xs: "center",
                                },
                                padding: "8px 0",
                                justifyContent: {
                                    md: "left",
                                    xl: "left",
                                    xs: "center",
                                },
                            }}
                        >
                            <ByzMuiTypography variant="body1" sx={{ marginBottom: "4px" }}>
                                {t("partograf-form.note")}
                            </ByzMuiTypography>

                            <ByzMuiTextField
                                sx={{
                                    width: "240px",
                                }}
                                inputProps={{ maxLength: 50 }}
                                color="primary"
                                variant="outlined"
                                label=""
                                value={formData.NOTE || ""}
                                onChange={(e: any) => handleChange("NOTE", e.target.value)}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Card>
    );
};

export default PartographBornInfo;
